<template>
  <a-modal
    wrapClassName="customModal"
    v-model="showDialog"
    :title="title"
    centered
    :width="600"
    destroyOnClose
    :maskClosable="false"
    @ok="confirmChange"
    @cancel="afterClose"
  >
    <div class="add-dialog-body">
      <div class="fail-tip" v-if="showFailTip">
        <a-icon type="close-circle" theme="filled" :style="{ fontSize: '16px', color: '#FE7D26' }" />
        <span class="tip-text">{{ failMsg || '操作失败' }}</span>
      </div>
      <div class="form-content">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item ref="pageName" label="输入名称" prop="pageName">
            <a-input
              v-model="form.pageName"
              placeholder="请输入大屏页名称，20字以内"
              @blur="
                () => {
                  $refs.pageName.onFieldBlur()
                }
              "
            />
          </a-form-model-item>
          <a-form-model-item label="输入介绍" prop="pageDescribe">
            <a-textarea v-model="form.pageDescribe" placeholder="请输入大屏介绍，200字以内" :rows="4" />
          </a-form-model-item>
          <a-form-model-item v-if="form.pageType === 2" ref="sourceType" label="选择资源类型" prop="sourceType">
            <a-radio-group v-model="form.sourceType" @change="onChangeSourceType">
              <a-radio :value="1">图片</a-radio>
              <a-radio :value="2">视频</a-radio>
              <a-radio :value="3">链接</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
            :class="form.sourceType !== 3 ? 'source-name' : ''"
            v-if="form.pageType === 2"
            ref="sourceName"
            :label="form.sourceType === 3 ? '输入链接地址' : '输入资源名称'"
            prop="sourceName"
          >
            <a-input
              v-model="form.sourceName"
              :placeholder="form.sourceType === 3 ? '请输入链接地址，http或https开头' : '请输入资源名称'"
            />
            <span class="image-tip" v-if="form.sourceType !== 3">支持拓展名: jpg; 尺寸: 10240 * 1200</span>
          </a-form-model-item>
          <a-form-model-item v-if="form.pageType === 1" ref="sourceName" label="选择本地图片">
            <span class="system-image-tip">系统大屏页不支持上传本地图片</span>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </a-modal>
</template>

<script>
import store from '@/store'

export default {
  props: {
    showAddDialog: {
      type: Boolean,
      default: false
    },
    showType: {
      type: Number // 1 添加 2 编辑
    },
    currentScreenInfo: {
      type: Object,
      default: null
    },
    panoramaClassroomCode: {
      type: String | Number
    }
  },
  watch: {
    showAddDialog(val, old) {
      this.showDialog = val
    }
  },
  computed: {
    title() {
      if (this.showType === 1) {
        return '添加大屏'
      } else {
        return '编辑大屏'
      }
    },
    form() {
      if (this.currentScreenInfo) {
        return this.currentScreenInfo
      }
    }
  },
  data() {
    let checkSourceName = (rule, value, callback) => {
      if (value === '') {
        if (this.form.sourceType === 3) {
          callback(new Error('请输入链接地址'))
        } else {
          callback(new Error('请输入资源名称'))
        }
      } else if (value != '' && this.form.sourceType === 3) {
        if (value.indexOf('http') !== 0 && value.indexOf('https') !== 0) {
          callback(new Error('链接地址必须要以http或https开头'))
        } else {
          callback()
        }
      } else if (value != '' && this.form.sourceType !== 3) {
        if (value.length > 200) {
          callback(new Error('资源名称长度不得超过200字'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      showDialog: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      rules: {
        pageName: [
          { required: true, message: '请输入大屏页名称', trigger: 'blur' },
          { min: 1, max: 20, message: '名称长度在1-20个字之内哦', trigger: 'change' }
        ],
        pageDescribe: [{ max: 200, message: '介绍长度不得超过200字', trigger: 'change' }],
        sourceType: [{ required: true, message: '请选择资源名称', trigger: 'blur' }],
        // sourceName: [
        //   { required: true, message: '请输入资源名称', trigger: 'change' },
        //   { max: 200, message: '资源名称长度不得超过200字', trigger: 'blur' }
        // ],
        sourceName: [{ validator: checkSourceName, trigger: 'change' }]
      },
      showFailTip: false,
      failMsg: ''
    }
  },
  methods: {
    afterClose() {
      this.$emit('update:showAddDialog', false)
    },
    onChangeSourceType(e) {
      this.$refs.ruleForm.clearValidate(['sourceName'])
    },
    confirmChange() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (this.showType === 2) {
            const formDataParams = new FormData()
            formDataParams.append('pages', JSON.stringify([this.form]))
            const res = await this.$http.batchUpdateScreen(formDataParams, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: store.getters['userInfo/token']
              }
            })
            if (res.code == 200) {
              this.$emit('editScreenlist')
              this.$message.success('操作成功')
              this.resetForm()
              this.afterClose()
            } else {
              this.showFailTip = true
              this.failMsg = res.msg
            }
          } else if (this.showType === 1) {
            const res2 = await this.$http.addScreenPage({
              panoramaClassroomCode: this.panoramaClassroomCode ? this.panoramaClassroomCode : undefined,
              ...this.form
            })
            if (res2.code == 200) {
              this.$emit('updateScreenlist')
              this.$message.success('操作成功')
              this.resetForm()
              this.afterClose()
            } else {
              this.showFailTip = true
              this.failMsg = res2.msg
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.add-dialog-body {
  .fail-tip {
    display: flex;
    align-items: center;
    height: 48px;
    padding-left: 15px;
    font-size: 14px;
    border: 1px solid #fe7d26;
    background: #faede4;
    color: #1e2228;
    .tip-text {
      margin-left: 12px;
    }
  }
}
::v-deep .ant-modal-body {
  padding: 15px 16px;
}
.form-content {
  margin-top: 16px;
  ::v-deep .ant-form {
    .ant-form-item-label > label {
      font-size: 14px;
      color: #515560;
    }
  }
  .image-tip {
    position: absolute;
    bottom: -26px;
    left: 0;
    line-height: 12px;
    font-size: 12px;
    color: #9ca5b1;
  }
  .system-image-tip {
    line-height: 32px;
    font-size: 12px;
    color: #9ca5b1;
  }
}
::v-deep .ant-modal-footer {
  padding: 20px;
  border-top: none;
  text-align: center;
  .ant-btn {
    width: 72px;
    height: 40px;
    border: 1px solid #5f60d3;
    color: #5f60d3;
  }
  .ant-btn-primary {
    margin-left: 16px;
    background: #5f60d3;
    color: #fff;
  }
}
.source-name {
  ::v-deep .ant-form-explain {
    margin-top: 14px;
  }
}
</style>
